import { render, staticRenderFns } from "./application-trade-in.vue?vue&type=template&id=798fba10&"
import script from "./application-trade-in.vue?vue&type=script&lang=js&"
export * from "./application-trade-in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Baner: require('/var/www/components/baner/baner.vue').default,BenefitsSlider: require('/var/www/components/benefits/benefits-slider.vue').default,FormTradeIn2: require('/var/www/components/form/form-trade-in2.vue').default,FormTradeIn2Desktop: require('/var/www/components/form/form-trade-in2-desktop.vue').default})
